7<template>
    <v-app id="inspire">
      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

       <v-container fluid fill-height align-start>
          <v-row>
            <v-col md="12" lg="12" cols="12">
              <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Mapa de Mesas {{negocio.negocio}}</h1>
              <br/>
             <v-card color="#393E46">
               <v-card-title>
                 Escoger Zona
               </v-card-title>
               <v-card-text>
                 <v-autocomplete
                     v-model="zonaselected"
                     :items="Zonas"
                     item-text="zona"
                     item-value="id"
                     label="Escoge Zona"
                     persistent-hint
                     return-object
                     single-line
                 ></v-autocomplete>
                 <v-dialog v-model="dialog" max-width="500px">
                   <template v-slot:activator="{ on }">
                     <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Mesa</v-btn>
                   </template>
                   <v-card color="#393E46">
                     <v-card-title>
                       <span class="headline">{{ formTitle }}</span>
                     </v-card-title>
                     <v-card-text>
                       <v-container>
                         <v-row>
                           <v-col cols="12" sm="6" md="12">
                             <v-text-field v-model="editedItem.espacio" label="Nombre"></v-text-field>
                           </v-col>
                           <v-col cols="12" sm="6" md="12">
                             <v-text-field v-model="editedItem.precio"   type="number" label="Costo"  ></v-text-field>
                           </v-col>
                           <v-col cols="12" sm="6" md="12">
                             <v-text-field v-model="editedItem.cantidad"   type="number" label="Cantidad de Personas en Box"  ></v-text-field>
                           </v-col>
                         </v-row>
                       </v-container>
                     </v-card-text>
                     <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                       <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                     </v-card-actions>
                   </v-card>
                 </v-dialog>
               </v-card-text>
             </v-card>
            </v-col>
            <v-col md="12" lg="12" cols="12"  ref="muestra">
              <v-card color="#393E46">
                <v-card-text>
              <konva-stage ref="stage" :config="configKonva"  @dragstart="handleDragstart"
                       @dragend="handleDragend"  @mousedown="handleStageMouseDown"
                       @touchstart="handleStageMouseDown" style="background: white;">
                <konva-layer ref="layer">

                  <v-tooltip bottom   v-for="item in mesasr" :key="item.id">
                    <template v-slot:activator="{ on, attrs }">
                      <konva-rect
                          v-bind="attrs"
                          v-on="on"
                          :config="{
                          x: item.x,
                          y: item.y,
                          id: item.id,
                          width:item.width,
                          height: item.height,
                          fill: item.fill,
                          stroke: 'black',
                          strokeWidth:2,
                          draggable: true,
                          text:item.name,
                          name: item.name
                          }"
                         @transformend="handleTransformEnd" >
                      </konva-rect>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <konva-text
                      v-for="item in mesasr"
                      :key="item.id"
                      :config="{
                                x: item.x + 10 ,
                                y: item.y + item.height/2 - 5,
                                id: item.id,
                                text:item.name,
                                fill: 'black'
                                }">{{item.name}}</konva-text>


                  <konva-transformer ref="transformer" />

                </konva-layer>

              </konva-stage>
                </v-card-text>  </v-card>

            </v-col>
        </v-row>
        <leftmenu :abreviado="abreviado" />
      </v-container>
     </v-main>
    </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Konva from 'konva';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Mapa Mesas | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negocio: {},
      progr: true,
      selectedShapeName:'',
      isDragging: false,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      abreviado:'NN',
      token:'',
      configKonva: {
        width: 600,
        height: 600
      },
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Mesas-Box',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      dialog: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,
      Zonas: [],
      search: '',
      editedIndex: -1,
      dragItemId: null,
      mesasr:[],
      zonaselected:{},
      editedItem: {
        espacio: '',
        precio: 0,
        cantidad:0,
        movible: true,
        zonaNegocio : {}
    },
    defaultItem: {
      espacio: '',
      precio: 0,
      movible: true,
      cantidad:0,
      zonaNegocio : {}
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Mesa', align: 'left',  value: 'espacio'},
        { text: 'Zona', value: 'zonaNegocio.zona' },
        { text: 'Valor', value: 'precio' }
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
    this.configKonva.width = this.$refs.muestra.clientWidth
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
              if (this.usuario.id === undefined){

                this.overlay = true
                firebase
                    .auth()
                    .onAuthStateChanged(user => {
                      if(user){
                        this.overlay = false
                        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                        this.damemesas();
                        this.dameZonas();
                      }else{
                        this.overlay = false
                        this.$router.push({ path: '/' });
                      }
                    })

         }else{
                this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                this.damemesas();
                this.dameZonas();
              }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.cliente": function (){
       this.damemesas();
       this.dameZonas();
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio;
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
            }else{
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

        this.damemesas();
        this.dameZonas();
      }
    },
  },
  methods : {
    handleDragstart(e) {
      // save drag element:
      this.isDragging = true
      this.dragItemId = e.target.id();
      // move current element to the top:
      const item = this.mesasr.find(i => i.id === this.dragItemId);
      const index = this.mesasr.indexOf(item);
      this.mesasr.splice(index, 1);
      this.mesasr.push(item);
    },
    handleDragend(e) {
      this.dragItemId = e.target.id();
      this.isDragging = false
      const item = this.mesasr.find(i => i.id === this.dragItemId);
      console.log(item)
      var bodyFormData = new FormData();
      bodyFormData.append("id",Number(item.id));
      bodyFormData.append("x",e.target.x());
      bodyFormData.append("y",e.target.y());
      bodyFormData.append("width",item.width);
      bodyFormData.append("height",item.height);

      axios
          .post('espacios/negocio/actualiza',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        let mesasss = response.data;
        this.mesasr = [];
        mesasss.forEach((entry)=>{
          let obj = {
            id: entry.id.toString(),
            x: entry.x,
            y: entry.y,
            width: entry.width,
            height: entry.height,
            name: entry.espacio,
            rotation: entry.rotation,
            scaleX: entry.scaleX,
            scaleY: entry.scaleY,
            fill : Konva.Util.getRandomColor(),
            draggable: entry.draggable
          }
          this.mesasr.push(obj)
        });
        this.alertnuevo = true;
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });

      this.dragItemId = null;
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
          e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.mesasr.find((r) => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.mesasr.find(
          (r) => r.name === this.selectedShapeName
      );
      // update the state
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
      rect.fill = Konva.Util.getRandomColor();
    },
    damemesas(){
      this.progr = true;
            let urMesa = 'espacios/negocio/zonatag/' + this.idnegocio ;
        axios
        .get(urMesa,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
          let mesasss = response.data;
          this.mesasr = [];
          mesasss.forEach((entry)=>{
            let obj = {
              id: entry.id.toString(),
              x: entry.x,
              y: entry.y,
              width: entry.width,
              height: entry.height,
              name: entry.espacio,
              rotation: entry.rotation,
              scaleX: entry.scaleX,
              scaleY: entry.scaleY,
              fill : entry.fill,
              draggable: entry.draggable
            }
            this.mesasr.push(obj)
          });
          this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },

    dameZonas(){
      this.progr = true;
      let urlZona = 'zonas/negocio/' + this.idnegocio ;
        axios
        .get(urlZona,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Zonas = response.data;
            if(this.Zonas.length>0){
              this.zonaselected = this.Zonas[0]
            }
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },


    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.zonaNegocio = this.zonaselected
        this.editedIndex = -1
      }, 300)
    },
    save () {

        var bodyFormData = new FormData();
        this.editedItem.zonaNegocio = this.zonaselected;
        this.editedItem.name = this.editedItem.espacio;
        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('espacios/negocio/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
          let mesasss = response.data;
          this.mesasr = [];
          mesasss.forEach((entry)=>{
              let obj = {
                id: entry.id.toString(),
                x: entry.x,
                y: entry.y,
                width: entry.width,
                height: entry.height,
                name: entry.espacio,
                rotation: entry.rotation,
                scaleX: entry.scaleX,
                scaleY: entry.scaleY,
                fill : entry.fill,
                draggable: entry.draggable
              }
              this.mesasr.push(obj)
          });
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });

      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Mesa' : 'Editar Mesa'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
